import { Action } from 'redux';
import { Flight } from '../../models/Flight/SearchParams';
import {
    ADD_FLIGHT,
    REMOVE_FLIGHT,
    SET_DATE,
    SET_DESTINATION,
    SET_ORIGIN
} from '../../actions/Flight/searchParams';
import moment from 'moment';
import { Airport } from '../../models/Flight/Airport';
import { SWAP_AIRPORTS } from '../../actions/Flight/airports';

export interface SearchParamsState {
    flights: Array<Flight>;
    size: number;
    airports: Array<{origin: Airport | null, destination: Airport | null}>;
}

const initialState: SearchParamsState = {
    flights: localStorage.flight_search_params ? JSON.parse(localStorage.flight_search_params).flights : [
        {
            origin: '',
            destination: '',
            date: ''
        },
        {
            origin: '',
            destination: '',
            date: ''
        }
    ],
    size: 2,
    airports: localStorage.flight_search_params ? JSON.parse(localStorage.flight_search_params).airports : [
        {
            origin: null,
            destination: null,
        },
        {
            origin: null,
            destination: null,
        }
    ],
};

export function searchParams(state: SearchParamsState = initialState, action: Action) {
    switch (action.type) {
        case SWAP_AIRPORTS: {
            let flights = state.flights.slice();
            let airports = state.airports.slice();
            state.flights.map((flight, i) => {
                if (i === 0) {
                    flights[0] = {origin: flight.destination, origin_type: flight.destination_type, destination: flight.origin, destination_type: flight.origin_type, date: flight.date};
                    return;
                }
            });
            state.airports.map((airport, i) => {
                if (i === 0) {
                    airports[0] = {origin: airport.destination, destination: airport.origin};
                    return;
                }
            });
            return {
                ...state,
                flights,
                airports
            };
        }
        case ADD_FLIGHT: {
            const flights = state.flights;
            flights.push({origin: '', origin_type: '', destination: '', destination_type: '', date: ''});
            const airports = state.airports;
            airports.push({origin: null, destination: null});
            return {
                ...state,
                flights,
                airports,
                size: state.size + 1
            };
        }
        case REMOVE_FLIGHT: {
            const index = (action as any).index;
            const flights = state.flights;
            flights.splice(index ? index : state.flights.length - 1, 1);
            const airports = state.airports;
            airports.splice(index ? index : state.airports.length - 1, 1);
            return {
                ...state,
                flights,
                airports,
                size: state.size - 1
            };
        }
        case SET_DATE: {
            const date = (action as any).date;
            const index = (action as any).index;
            let flights = state.flights;
            state.flights.map((flight, i) => {
                if (index === i) {
                    flights[index] = {origin: flight.origin, origin_type: flight.origin_type, destination: flight.destination, destination_type: flight.destination_type, date};
                    return;
                }
            });
            let airports = state.airports;
            let isSorted = false;
            while (!isSorted) {
                isSorted = true;
                for (let i = 0; i < flights.length - 1; i++) {
                    if (moment(flights[i].date) > moment(flights[i + 1].date)) {
                        isSorted = false;
                        const newFlight: Flight = flights[i];
                        flights[i] = {origin: flights[i + 1].origin, origin_type: flights[i + 1].origin_type, destination: flights[i + 1].destination, destination_type: flights[i + 1].destination_type, date: flights[i + 1].date};
                        flights[i + 1] = {origin: newFlight.origin, origin_type: newFlight.origin_type, destination: newFlight.destination, destination_type: newFlight.destination_type, date: newFlight.date};
                        const newAirport = airports[i];
                        airports[i] = airports[i + 1];
                        airports[i + 1] = newAirport;
                    }
                }
            }
            return {
                ...state,
                flights,
                airports
            };
        }
        case SET_ORIGIN: {
            const airport: Airport = (action as any).airport;
            const index = (action as any).index;
            let flights = state.flights;
            state.flights.map((flight, i) => {
                if (index === i) {
                    flights[index] = {origin: airport.code, origin_type: airport.type, destination: flight.destination, destination_type: flight.destination_type, date: flight.date};
                    return;
                }
            });
            let airports = state.airports;
            if (airports.length - 1 < index) {
                airports.push({origin: null, destination: null});
            }
            airports.map((newAirport, i) => {
                if (index === i) {
                    airports[index].origin = airport;
                    return;
                }
            });
            return {
                ...state,
                flights,
                airports
            };
        }
        case SET_DESTINATION: {
            const airport: Airport = (action as any).airport;
            const index = (action as any).index;
            let flights = state.flights;
            state.flights.map((flight, i) => {
                if (index === i) {
                    flights[index] = {origin: flight.origin, origin_type: flight.origin_type, destination: airport.code, destination_type: airport.type, date: flight.date};
                    return;
                }
            });
            let airports = state.airports;
            if (airports.length - 1 < index) {
                airports.push({origin: null, destination: null});
            }
            airports.map((newAirport, i) => {
                if (index === i) {
                    airports[index].destination = airport;
                    return;
                }
            });
            return {
                ...state,
                flights,
                airports
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Flight/searchParams.ts